const BenefitsManagement = {
  // A
  add_endorsments: 'إضافة موظف جديد',
  add_endorsment_verify: 'التحقق',
  add_endorsment_cancel: 'حذف',
  add_endorsment_continue: 'المتابعة',
  add_endorsment_save_close: 'الحفظ والإغلاق',
  assign_policy: 'اختر الوثيقة',
  all_changes_saved: 'جميع التغييرات حُفظت',
  add_endorsement: 'تأمين موظف',
  add_dependent: 'إضافة تابع',
  attachment_type_list: 'PDF or JPG (10mb .كحد أقصى)',
  action_required: 'الإجراء مطلوب',
  active_bill_notice: 'إشعار الفاتورة النشطة',
  active_bill_msg:
    'يمكنك إنشاء فاتورة جديدة فقط بعد انتهاء صلاحية الفاتورة النشطة. تكون كل فاتورة صالحة لمدة أسبوعين.',
  add_another_endorsement: 'إضافة طلب آخر',
  action_required_msg:
    'برجاء زيارة حسابك على تعاونية لتكملة الإجراءات المطلوبة بخصوص طلب رقم {{request_num}}',

  // B
  benefits_management: 'إدارة المزايا والمكافآت',
  benefits_management_insurance: 'التأمين الصحي',
  benefits_management_health_insurance: 'التأمين الصحي',
  benefits_management_policies: 'وثائقك',
  benefits_management_class: 'فئة التأمين',
  back_to_insurance: 'العودة للتأمين الصحي',
  beddon: 'Beddon AR',
  border_no: 'Border No. AR',
  sadad_bill_number: 'رقم فاتورة سداد',

  // C
  copy_of_visit_type: 'Copy of Visit Type AR',
  company_unified_no: 'Company Unified No. AR',
  cancel_add_endorsement_msg: 'هل تريد حذف الطلب؟',
  card_code: 'رمز البطاقة',
  cancel_dependent_msg: 'هل أنت متأكد من حذف هذا التابع؟',
  connect_policy: 'ربط وثيقة',
  // D
  dependent: 'تابع',
  dependents: 'التابعين',
  download_document: 'تحميل الوثيقة',
  dob: 'Date of Birth AR',
  dependents_relation: 'صلة قرابة التابع',
  dependent_national_id_iqama: 'رقم الهوية/الاقامة للتابع',

  // E
  endorsements: 'الطلبات',
  external_nationalities: 'الجنسيات',
  endorsement_details: 'تفاصيل الطلب',
  endorsement_payment: 'الدفع',
  endorsement_due_date: 'تاريخ الإنتهاء',
  employee_national_id_iqama: 'رقم الهوية/الاقامة للموظف',

  // F

  // G
  gcc_member: 'GCC Member AR',
  gcc_id_or_passport_no: 'GCC ID/Passport No AR',
  gosi_print: 'GOSI Print AR',
  generate_bill: 'إنشاء فاتورة',

  // H
  health_declaration: 'الإفصاح الطبي',

  // I
  insurance_sub_title: 'أمن في دقائق!',
  insurance_status: 'الحالة',
  insurance_policy: 'الوثيقة',
  insurance_type: 'نوع التأمين',
  insurance_id: 'الهوية',
  insurance_details: 'تفاصيل التأمين',
  insurance_filter_lable: 'التصفية',
  insurance_effective_date: 'تاريخ التفعيل',
  insurance_statuse_draft: 'مسودة',
  insurance_statuse_completed: 'مكتملة',
  insurance_statuse_rejected: 'مرفوضة',
  insurance_statuse_pending_approval: 'في انتظار الموافقة',
  insurance_policy_class: 'فئات التأمين',
  insurance_policy_number: 'رقم الوثيقة',

  // L
  load_employee_details: 'التحقق من الهوية',
  linked: 'مضاف',

  // M
  member_card_code: 'رمز البطاقة',
  member_full_name: 'Member full name AR',
  member_id: 'Member ID AR',
  members: 'إجمالي الأعضاء',
  member: 'عضو',
  member_details: 'معلومات العضو',
  member_employees_count: '{{count}} موظفين',
  member_dependents_count: '{{count}} تابعين',
  members_not_linked_with_jisr: 'مؤمن عليهم غير مضافين على منصة {{app_name}} كموظفين',
  member_linked: 'حالة الإضافة في ',

  // N
  natural_numbers_validation_msg: 'ادخل قيم رقميه فقط',
  no_endorsements_yet: 'لا يوجد طلبات حتى الآن.',
  no_policies_yet: 'لا يوجد وثائق حتى الآن.',
  not_linked_member_info:
    'بيانات هذا الموظف المؤمن عليه غير موجودة على منصة {{app_name}} ، يرجي إضافته كموظف جديد',
  not_linked: 'غير مضاف',
  // O

  // P
  policy_details: 'تفاصيل الوثيقة',
  premium: 'تكلفة التأمين',
  policy_document: 'مستند الوثيقة',
  pending_payment: 'في انتظار الدفع',

  // Q

  // R
  reation: 'العلاقة',
  rejection_reasons: 'أسباب الرفض',

  // S
  select_policy: 'اختر الوثيقة',
  select_class: 'اختر الفئة',
  save_dependent: 'حفظ التابع',
  sponsor_no: 'Sponsor No. AR',
  submit_endo_heading: 'تم تقديم طلبك لإضافة عضو {{number}} بنجاح',
  submit_endo_subHeading:
    'سيتم مراجعة الطلب من قبل فريق "{{provider_name}}" وسيتم الرد عليك خلال يوم عمل واحد.',
  sync_endosements_statuses_tooltip: 'مزامنة حالة الطلبات',
  sync_policies_tooltip: ' مزامنة فئات الموظفين مع الوثائق',
  sync_members_tooltip: 'مزامنة بيانات المؤمن عليهم في هذه الوثيقة',
  submit_endorsement_msg: 'هل أنت متأكد من إرسال هذا الطلب؟',

  // T
  the_member: 'العضو',
  total_members: 'إجمالي الأعضاء ({{count}})',

  // U
  under_review: 'تحت المراجعة',

  // V
  verification: 'التحقق من الهوية',

  // W

  // X

  // Y
  your_changes_will_be_saved: 'تغييراتك سيتم حفظها',

  // Z
}

export default BenefitsManagement
